import OligoEditor from "./oligo/oligoEditors"
import Mediator from "./mixins/mediator";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".editor").forEach((el) => {
        const slotted = el.dataset.editorSlotted !== undefined;
        const isEditable = el.dataset.editable !== undefined;
        const mediator = new Mediator();
        const oligoEditors = new OligoEditor({
            "hasSlots": slotted,
            "user_id": el.dataset.userId,
            "ws_path": el.dataset.wsPath,
            "contextId": el.dataset.contextId,
            "contextType": el.dataset.contextType,
            "editable": isEditable ?? false,
            "type_map": JSON.parse(document.getElementById("types").innerHTML),
        },mediator)

        oligoEditors.initWS();
        window.editor = oligoEditors;
    })
});